import React from 'react'

import { ExternalLink, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

import { parseWebUrl } from '../../../../Utils/Video'

const ACTIVATION_KEYS = ['Enter', ' ']

// The card sits inside clickable carousels that open the gallery. Only activation keys are
// stopped so Escape still reaches the gallery's document-level close handler.
const stopPropagation = (event) => event.stopPropagation()
const stopActivationKeyPropagation = (event) => {
  if (ACTIVATION_KEYS.includes(event.key)) event.stopPropagation()
}

function LinkPreview({ url }) {
  const { t } = useUseCaseTranslate()
  const href = parseWebUrl(url)

  if (!href) {
    return <div className="use-case-link" />
  }

  const hostname = new URL(href).hostname.replace(/^www\./, '')

  return (
    <div className="use-case-link">
      <Icon svgComponent={ExternalLink} size="small" color="dark" />
      <span className="use-case-link__host cgt-body-base-semibold" title={hostname}>
        {hostname}
      </span>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="use-case-link__open cgt-link-primary-accented cgt-caption"
        onClick={stopPropagation}
        onKeyDown={stopActivationKeyPropagation}
      >
        {t('viewer.openLink')}
      </a>
    </div>
  )
}

LinkPreview.propTypes = {
  url: string.isRequired,
}

export default LinkPreview
